<template>
  <div class="card">
    <Form @submit="onSubmit" :validation-schema="schema">
      <div class="card-header">
        <h4 class="card-title">User | Create</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <TextInput
            :value="user.email"
            name="email"
            type="email"
            label="E-mail"
            placeholder="Your email address"
            success-message="Good!"
          />

          <SelectInput
            :value="user.namespace"
            name="namespace"
            :options="namespaces"
            label="Namespace"
            placeholder="--- Select namespace ---"
            success-message="Good!"
          />

          <SelectInput
            :value="user.role"
            name="role"
            :options="roles"
            label="Role"
            placeholder="--- Select role ---"
            success-message="Good!"
          />

          <SelectInput
            :value="user.status"
            name="status"
            :options="statuses"
            label="Status"
            placeholder="--- Select status ---"
            success-message="Good!"
          />

          <TextInput
            name="password"
            type="password"
            label="Password"
            placeholder="Your password"
            success-message="Nice and secure!"
          />
          <TextInput
            name="confirm_password"
            type="password"
            label="Confirm Password"
            placeholder="Type it again"
            success-message="Glad you remembered it!"
          />
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-xl-12">
            <div role="group" class="float-right btn-group">
              <button type="submit" class="btn btn-success btn-sm">Save</button>
            </div>
          </div>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import { Form } from "vee-validate";
import * as Yup from "yup";
import {
  checkEmailAddress,
  createUser,
  namespaceList,
  roleList,
  statusList,
} from "../../controllers/user-contoller";
import TextInput from "../../components/TextInput";
import { useRouter } from "vue-router";
import SelectInput from "../../components/SelectInput";

export default {
  name: "UserCreate",
  components: {
    Form,
    TextInput,
    SelectInput,
  },
  async setup() {
    const router = useRouter();
    const user = {
      email: "",
      status: "",
      role: "",
      namespace: "",
    };

    async function onSubmit(values) {
      try {
        await createUser(values);
        await router.push({ name: "UserList" });
      } catch (e) {
        alert("something went wrong");
      }
    }

    const schema = Yup.object().shape({
      role: Yup.string().required(),
      namespace: Yup.string().required(),
      status: Yup.string().required(),
      email: Yup.string()
        .email()
        .required()
        .test("Unique Email", "Email already in use", async function (value) {
          const { data } = await checkEmailAddress(value);
          return !data;
        }),
      password: Yup.string().required().min(5),
      confirm_password: Yup.string()
        .required()
        .oneOf([Yup.ref("password")], "Passwords do not match"),
    });

    return {
      onSubmit,
      schema,
      user,
    };
  },
  data: () => {
    return {
      namespaces: namespaceList,
      roles: roleList,
      statuses: statusList,
    };
  },
};
</script>
